import { render, staticRenderFns } from "./cvs-selector.vue?vue&type=template&id=4df1f4a2&lang=pug&"
import script from "./cvs-selector.vue?vue&type=script&lang=js&"
export * from "./cvs-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports